import { useSearchParams } from 'react-router'

import { EMPTY_OBJECT } from '../../../../../constants/common'
import { PAGINATION_PAGE_PARAM } from '../../../../../constants/pagination'

import {
  getApplicantsClearedFilterParamList,
  getApplicantsFilterParams,
  getApplicantsFilterValues,
} from './useRentalPortalApplicantsFilters.utils'

export function useRentalPortalApplicantsFilters({ availableFilters }) {
  const [searchParams, setSearchParams] = useSearchParams()

  const filterValues = getApplicantsFilterValues({
    availableFilters,
    searchParams,
  })

  function handleSetFilterValues(nextFilterValues, extraParams) {
    setSearchParams(
      params => {
        const nextParams = new URLSearchParams(params)

        nextParams.delete(PAGINATION_PAGE_PARAM)

        getApplicantsClearedFilterParamList(availableFilters).forEach(param =>
          nextParams.delete(param)
        )

        getApplicantsFilterParams(nextFilterValues).forEach(([param, value]) =>
          nextParams.append(param, value)
        )

        Object.entries(extraParams || EMPTY_OBJECT).forEach(([param, value]) =>
          nextParams.set(param, value)
        )

        return nextParams
      },
      { replace: true }
    )
  }

  function handleClearFilters() {
    handleSetFilterValues(EMPTY_OBJECT)
  }

  return { filterValues, handleClearFilters, handleSetFilterValues }
}
